import serviceAreaApi from "@/api/serviceArea";

export default {
  actions: {
    async create({ dispatch }, data) {
      await serviceAreaApi.create(data);
      await dispatch("fetchList");
    },
    async getServiceArea({ commit }, serviceAreaId) {
      commit("setServiceAreaRecordLoader", true);
      const serviceArea = await serviceAreaApi.get(serviceAreaId);
      commit("setServiceAreaRecordLoader", false);
      return commit("setServiceArea", serviceArea.data.result);
    },
    async fetchList({ commit, state }, { includeInactive = state.includeInactive } = {}) {
      commit("setIncludeInactive", includeInactive);
      commit("setLoadingList", true);
      try {
        const response = await serviceAreaApi.list({ includeInactive });
        commit("setList", response.data.result);
      } finally {
        commit("setLoadingList", false);
      }
    },
    async update({ dispatch }, data) {
      await serviceAreaApi.update(data);
      await dispatch("fetchList");
    },
    async patchUpdate({ dispatch }, { serviceAreaId, data }) {
      await serviceAreaApi.patchUpdate(serviceAreaId, data);
      await dispatch("getServiceArea", serviceAreaId);
    },
  },
  getters: {
    getServiceAreaMap: state => {
      return state.list.reduce((acc, serviceArea) => {
        acc[serviceArea.id] = serviceArea;
        return acc;
      }, {});
    },
  },
  mutations: {
    setEdit(state, serviceArea) {
      state.edit = serviceArea;
    },
    setIncludeInactive(state, value) {
      state.includeInactive = value;
    },
    setList(state, list) {
      state.list = list;
    },
    setLoadingList(state, isLoading) {
      state.loadingList = isLoading;
    },
    setServiceArea(state, serviceArea) {
      state.record = serviceArea;
    },
    setServiceAreaRecordLoader(state, isLoading) {
      state.isLoadingServiceAreaRecord = isLoading;
    },
  },
  namespaced: true,
  state: {
    edit: {},
    includeInactive: false,
    list: [],
    loadingList: false,
    record: {},
    isLoadingServiceAreaRecord: false,
  },
};
